import React from "react";
import { Select, Form } from "antd";
import PropTypes from "prop-types";

import FormLabel from "components/FormLabel/FormLabel";

const FormItem = Form.Item;
const { Option } = Select;

const FormSelection = ({
  disabled,
  extraProps,
  label,
  name,
  onFocus,
  placeholder,
  requiredErrorMessage,
  selections,
  isSearchable,
  onChange,
  mandatory,
}) => {
  const generatePropsForRules = () => {
    const rules = [];
    if (requiredErrorMessage && typeof requiredErrorMessage === "string") {
      rules.push({
        required: mandatory,
        message: requiredErrorMessage,
      });
    }
    return rules;
  };

  const searchProps = isSearchable
    ? {
        showSearch: true,
        filterOption: (input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      }
    : {};

  return (
    <>
      {label && <FormLabel>{label}</FormLabel>}
      <FormItem
        rules={generatePropsForRules()}
        name={name}
        onFocus={() => onFocus(name)}
      >
        <Select
          disabled={disabled}
          placeholder={placeholder}
          onChange={onChange}
          {...searchProps}
          {...extraProps}
        >
          {selections.map((selection) => (
            <Option key={selection.label} value={selection.value}>
              {selection.label}
            </Option>
          ))}
        </Select>
      </FormItem>
    </>
  );
};

FormSelection.propTypes = {
  isSearchable: PropTypes.bool,
  onFocus: PropTypes.func,
  mandatory: PropTypes.bool,
};

FormSelection.defaultProps = {
  mandatory: true,
  isSearchable: true,
  onFocus: () => {},
};

export default FormSelection;
